import React from "react";

const COND_STYLE = {
  "Mint": "#10B981", "Near Mint": "#2DD4BF", "Excellent": "#3B82F6",
  "Light Played": "#F59E0B", "Played": "#F97316", "Poor": "#EF4444",
};

export function ConditionBadge({ value }) {
  const c = COND_STYLE[value] || "#CBD5E1";
  return (
    <span data-testid="condition-badge" className="inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[11px] font-semibold"
      style={{ color: c, borderColor: `${c}55`, background: `${c}14` }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: c }} />{value}
    </span>
  );
}

export function Tag({ children, tone = "#CBD5E1", testid }) {
  return (
    <span data-testid={testid} className="inline-flex items-center rounded-md border px-1.5 py-0.5 text-[11px] font-medium"
      style={{ color: tone, borderColor: `${tone}44`, background: `${tone}12` }}>
      {children}
    </span>
  );
}

const STATUS_TONE = {
  bozza: "#94A3B8", inviata: "#3B82F6", rifiutata: "#EF4444", superata: "#94A3B8",
  annullata: "#94A3B8", accettata: "#2DD4BF", completata: "#10B981", contestata: "#F59E0B",
};
const STATUS_LABEL = {
  bozza: "Bozza", inviata: "Inviata", rifiutata: "Rifiutata", superata: "Superata da controproposta",
  annullata: "Annullata", accettata: "Accettata", completata: "Completata", contestata: "Contestata",
};
export function StatusBadge({ status }) {
  const tone = STATUS_TONE[status] || "#CBD5E1";
  return <Tag tone={tone} testid={`status-${status}`}>{STATUS_LABEL[status] || status}</Tag>;
}
